import { Pipe, PipeTransform } from '@angular/core';
import { collator } from '../../utils/string-collator';

@Pipe({
  name: 'orderBy',
})
export class OrderByPipe implements PipeTransform {
  transform<T>(
    arr: T[] | undefined | null,
    ...args: (keyof T | { field?: keyof T; order: 'asc' | 'desc' })[]
  ): T[] | null {
    if (!arr) return null;
    if (args === undefined || args.length === 0) return [...arr].sort();
    return [...arr].sort((a, b) => {
      for (const arg of args) {
        let comparison: number;
        let order: number =
          (typeof arg === 'object' ? arg.order : 'asc') == 'desc' ? -1 : 1;
        if (
          (typeof a === 'number' && typeof b === 'number') ||
          (a instanceof Date && b instanceof Date)
        ) {
          comparison = +a - +b;
        } else if (typeof a === 'string' && typeof b === 'string') {
          comparison = collator.compare(String(a).trim(), String(b).trim());
        } else {
          let tKey: keyof T;
          if (typeof arg === 'object' && !!arg.field) {
            tKey = arg.field;
          } else if (typeof arg !== 'object') {
            tKey = arg;
          } else {
            throw new TypeError('object arrays must have a field defined');
          }
          if (
            (typeof a[tKey] === 'number' && typeof b[tKey] === 'number') ||
            (a[tKey] instanceof Date && b[tKey] instanceof Date)
          ) {
            comparison = +a[tKey] - +b[tKey];
          } else {
            comparison = collator.compare(
              String(a[tKey]).trim(),
              String(b[tKey]).trim()
            );
          }
        }

        if (comparison != 0) return comparison * order;
      }
      return 0;
    });
  }
}
